import { Component, Input } from '@angular/core';

import { Movie } from '@usheru-hff/shared/domain';
/**
 * Component to display the trReasonsToWatch from a movie.
 */
@Component({
  selector: 'ush-movie-reasons-to-watch',
  templateUrl: './movie-reasons-to-watch.component.html',
  styleUrls: ['./movie-reasons-to-watch.component.scss']
})
export class MovieReasonsToWatchComponent {
  /**
   * @docsNotRequired
   */
  @Input()
  movie: Movie;
}
